export default "__VITE_ASSET__DIO9DpvZ__"